export default __webpack_public_path__ + "static/media/innovation-switch-mob-rebrand.11fade8c.jpg";